import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    icon: {
      transform: 'scale(1.2)',
    },
  }),
);
